<!-- Conduct Component -->

<template>
  <div class="terms-page">
    <section>
      <div class="container text-center">
        <h1 class="text-white banner-title">CWB terms & policies</h1>
        <p class="banner-sub">
          Here you’ll find everything you need to know about our Terms of
          Service and Policies.
        </p>
      </div>
    </section>

    <div class="container">
      <el-row>
        <el-col :md="24" :lg="6" :xl="6">
          <div class="terms-policies">
            <terms-policies></terms-policies>
          </div>
        </el-col>

        <el-col :md="24" :lg="18" :xl="18">
          <div class="code-of-conduct">
            <h2 id="main-content" class="title">{{ conductText.title }}</h2>
            <p>{{ conductText.sub }}</p>
          </div>
          <div class="code-of-conduct">
            <ul>
              <li v-for="point in bodyText">
                <h2 class="sub-title">{{ point.title }}</h2>
                <p>{{ point.sub }}</p>
                <p v-if="point.secondSub">{{ point.secondSub }}</p>
                <p v-if="point.thirdSub">{{ point.thirdSub }}</p>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import TermsPolicies from "../../components/partials/terms-policies";
export default {
  name: "code-of-conduct",
  metaInfo: {
    title: "Code of conduct",
    meta: [
      {
        name: "description",
        content:
          "Read the code of conduct to be followed by all members of the CWB network.",
      },
    ],
  },
  components: {
    TermsPolicies,
  },
  data() {
    return {
      conductText: {
        title: "Code of conduct",
        sub: "To make sure our network offers a great experience for everyone, we ask all our members to follow our code of conduct. These principles have been at the heart of our network since it was formed in 2001. This code of conduct applies to both GlobalScots and business members.",
      },
      bodyText: [
        {
          title: "1. Always remember the purpose of the network",
          sub: "GlobalScot is an international business network committed to supporting Scotland’s economic success, through sharing connections and learning from shared experiences. It is not a direct business development or selling network. We have a shared vision of helping Scotland – its businesses, its economy and itscommunities – to thrive. ",
        },
        {
          title: "2. Join for the right reasons",
          sub: "GlobalScots are passionate about helping businesses in Scotland and about supporting Scotland’s economic success. GlobalScots don’t join for personal, professional or financial gain. If you join, you must be willing to share your expertise and give your time for free.",
          secondSub:
            "Business members join to access the knowledge, skills and connections that our GlobalScots can offer. It shouldn’t be about promoting your business to other users.",
        },
        {
          title: "3. Posting on the network",
          sub: "We want our network to be a spam-free platform. Our network – and particularly our community feed – is a place to ask genuine questions, share insights and start conversations. Don’t use it to simply advertise your company, your servicesor your products. And don’t use it to share content that’s not relevant to the community. ",
          secondSub:
            "Business members and GlobalScots should not use the network and the platform to buy or sell goods or services unless clearly and specifically invited to do so.",
        },
        {
          title: "4. Your time commitment",
          sub: "We understand that our GlobalScots and our business members are busy people.",
          secondSub:
            "We don’t expect our GlobalScots to give up an unreasonable amount of time. You’re free to manage which requests you accept, what types of businesses you work with and how many requests you work on at a time. You can ask our adminsto temporarily pause new requests if you know you can't offer support for a while. However, if we notice that you’ve not accepted any requests in a long time, we might get in touch to see how we can help you engage with more businesses.",
          thirdSub:
            "Business members should remember that GlobalScots are giving up their time for free. You shouldn’t ask an unreasonable amount from them.",
        },
        {
          title: "5. Interacting with other users",
          sub: "GlobalScots and business members should work together in a clear, courteous and professional manner. Respect each other’s time and contributions. No one likes having their time wasted, but remember that we’re all human and sometimes work, health or personal issues can get in the way. ",
        },
        {
          title: "What happens if I don’t follow the code of conduct?",
          sub: "To maintain the value of the network, we may remove GlobalScots or business members if we need to. For example, we might remove you from the network if you don’t follow our code of conduct, if your circumstances change and you’re nolonger suitable for the network, or if your membership may cause damage to theGlobalScot reputation.",
        },
        {
          title: "Giving feedback",
          sub: "Regular feedback helps us improve the network and make sure it’s providing value to all members. We’ll sometimes ask you to review your experience of the network – whether it’s an engagement with a specific user or an event. It’s not mandatory, but it can be really helpful.",
          secondSub:
            "If you notice a user who isn’t following the code of conduct, feel free to get in touch with our admins.",
        },
        {
          title: "Disclaimer",
          sub: "We’re an altruistic network and we do not create or regulate any financial or other legal relationships. If GlobalScots and business members wish to enter into financial or other legal relationships (e.g. confidentiality agreements) they should do so separately from GlobalScot. Scottish Enterprise and the other public bodies connected with GlobalScot will not accept any liability arising from their role in GlobalScot to the fullest extent permitted by law. If any legal consequences arise they shall be governed by the law of Scotland and be subject to the exclusive jurisdiction of the Scottish Courts.",
        },
      ],
    };
  },
};
</script>
